import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AuthProvider, useAuth } from './context/AuthContext'
import Sidebar from './components/ui/Sidebar'
import MobileNav from './components/ui/MobileNav'
import Login       from './pages/Login'
import POS         from './pages/POS'
import Caja        from './pages/Caja'
import Productos   from './pages/Productos'
import Categorias  from './pages/Categorias'
import Recepcion   from './pages/Recepcion'
import Reportes    from './pages/Reportes'
import Arqueo      from './pages/Arqueo'
import Usuarios    from './pages/Usuarios'
import Superadmin  from './pages/Superadmin'
import Suscripciones from './pages/Suscripciones'

const Layout = ({ children }) => (
  <div className="app-layout">
    <Sidebar/>
    <main className="main-content">{children}</main>
    <MobileNav/>
  </div>
)

const PrivateRoute = ({ children }) => {
  const { usuario, cargando } = useAuth()
  if (cargando) return <div className="page-loading"><div className="spinner"/></div>
  return usuario ? <Layout>{children}</Layout> : <Navigate to="/login"/>
}

const SuperadminRoute = ({ children }) => {
  const { usuario, cargando } = useAuth()
  if (cargando) return <div className="page-loading"><div className="spinner"/></div>
  if (!usuario) return <Navigate to="/login"/>
  if (usuario.rol !== 'superadmin') return <Navigate to="/pos"/>
  return children
}

const PublicRoute = ({ children }) => {
  const { usuario, cargando } = useAuth()
  if (cargando) return <div className="page-loading"><div className="spinner"/></div>
  return usuario ? <Navigate to="/pos"/> : children
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login"      element={<PublicRoute><Login/></PublicRoute>}/>
      <Route path="/pos"        element={<PrivateRoute><POS/></PrivateRoute>}/>
      <Route path="/caja"       element={<PrivateRoute><Caja/></PrivateRoute>}/>
      <Route path="/productos"  element={<PrivateRoute><Productos/></PrivateRoute>}/>
      <Route path="/categorias" element={<PrivateRoute><Categorias/></PrivateRoute>}/>
      <Route path="/recepcion"  element={<PrivateRoute><Recepcion/></PrivateRoute>}/>
      <Route path="/inventario" element={<Navigate to="/categorias"/>}/>
      <Route path="/reportes"   element={<PrivateRoute><Reportes/></PrivateRoute>}/>
      <Route path="/cierres-caja" element={<PrivateRoute><Arqueo/></PrivateRoute>}/>
      <Route path="/usuarios"   element={<PrivateRoute><Usuarios/></PrivateRoute>}/>
      <Route path="/superadmin" element={<SuperadminRoute><Superadmin/></SuperadminRoute>}/>
      <Route path="/suscripciones" element={<SuperadminRoute><Suscripciones/></SuperadminRoute>}/>
      <Route path="*" element={<Navigate to="/pos"/>}/>
    </Routes>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes/>
        <Toaster position="top-right" toastOptions={{
          style: { fontSize: 13, borderRadius: 8, border: '1px solid #e8e8e4' }
        }}/>
      </BrowserRouter>
    </AuthProvider>
  )
}
